import { Component, ComponentRef, Injector, Input, NgZone, ViewContainerRef, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { BaseComponentWithDialog } from "../../../admin-panel/base-admin-panel/base-component-with-dialog";
import { DriversViewModel } from "../../../admin-panel/Drivers/models/DriversViewModel";
import { EditDriverComponent } from "../../../admin-panel/Drivers/edit-driver.component";
import { CreateDriverComponent } from "../../../admin-panel/Drivers/create-driver.component";
import { JSProxyService } from "../../../../services/jsproxy.service";

import { ObjectGroupViewModel } from "../../../admin-panel/ObjectGroupViewModel";
import { GroupManagementDialogComponent } from "../../../admin-panel/group-management-dialog/group-management-dialog.component";

@Component({
    selector: 'app-drivers-list',
    templateUrl: './drivers-list.component.html',
    styleUrls: ['./drivers-list.component.css'],
    standalone: false
})
export class DriversListComponent extends BaseComponentWithDialog implements OnInit,OnDestroy
{
  groupMgmtDialog: ComponentRef<any>;
  @ViewChild("groupMgmtDialog", /* TODO: add static flag */ {static: true, read: ViewContainerRef }) groupsContainer;

  jsProxy: JSProxyService;
  ngZone: NgZone;
  constructor(protected injector: Injector)
  {
    super(injector);
    this.jsProxy = injector.get(JSProxyService);
    this.ngZone = injector.get(NgZone);
  }
  ngOnInit()
  {
    this.jsProxy.registerComponent("DriverEditor", this, "");
  }
  ngOnDestroy()
  {
    this.jsProxy.unRegisterComponent("DriverEditor");
  }
  public show(id) {
    this.ngZone.run(() => {
      this.prepareModal(EditDriverComponent);
      this.componentRef.instance.show(id);
    });
  }

  public edit(driver: DriversViewModel) {
    this.prepareModal(EditDriverComponent);
    this.componentRef.instance.open(driver);
  }

  public сreate() {
    this.prepareModal(CreateDriverComponent);
    this.componentRef.instance.open(new DriversViewModel());
  }
  public createGroup()
  {
      this.ngZone.run(() =>
      {
          this.groupMgmtDialog = this.dialogService.open(this.groupsContainer, GroupManagementDialogComponent);

          this.groupMgmtDialog.instance.onSubmit.subscribe(() =>
          {
              //let input = this.groupMgmtDialog.instance.object as ObjectGroupViewModel;
              //input.objects = this.groupMgmtDialog.instance.objects.map(driver => driver.Id);
        
              //this.objectsService.CreateGroup(input).subscribe(() => {
              //    this.syncService.NotifyEntityChanged(this.groupName, input.Name);
              //});
            this.groupMgmtDialog.instance.close();
          });

          this.groupMgmtDialog.instance.open(new ObjectGroupViewModel());
      });
  }
}
